import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/index'
import './quasar'
import api from '@/api/apiHelper'
import './plugins/sentry'
import './plugins/datadog'
import './plugins/highchartvue'
import './plugins/echo'
//import './registerServiceWorker' //TODO: generate a service worker to be imported

import { createProvider } from './vue-apollo'
import { AUTH_CHECK } from '@/store/modules/auth/actions'

api.config({
  store,
  onShowSpinner(message) {
    store.dispatch('showSpinner', message)
  },
  onHideSpinner() {
    store.dispatch('hideSpinner')
  }
})

Vue.config.productionTip = false

store
  .dispatch(AUTH_CHECK)
  .then(() => {
    bootApp()
  })
  .catch(() => {
    bootApp()
  })

function bootApp() {
  new Vue({
    router,
    store,
    apolloProvider: createProvider(),
    render: h => h(App)
  }).$mount('#app')
}
